import utils from "./firebase/firebaseUtils";
// import auth from "./firebaseAuth";
import game from "./firebase/game";
import question from "./firebase/question";
import player from "./firebase/player";
import submission from "./firebase/submission";
import editor from "./firebase/editor";
import superlatives from "./firebase/superlatives";
import host from "./firebase/host";
import trivia from "./firebase/trivia";
import { ClerkAuthProvider } from "./auth/clerk-auth";

const clerkProvider = ClerkAuthProvider.getInstance();

const api = {
  initialize: async () => {
    await utils.initialize();
    await clerkProvider.init();
  },
  stopWatching: utils.stopWatching,
  // ...auth,
  ...game,
  ...question,
  ...player,
  ...submission,
  ...editor,
  ...superlatives,
  ...host,
  ...trivia,
};

export default api;
